App.module('MessageCenterApp.Messages', function(Messages, App, Backbone, Marionette, $, _){
    'use strict';

    Messages.Controller = Marionette.Controller.extend({
        initialize: function(){
            this.messageCenterView = new App.MessageCenterApp.Views.MessageCenter({});
        },

        initMessageCenter: function(){
            var self = this,
                requestMessageListData;

            // load and print count new messages
            fetchMessages(initCountMessages);

            // on first time open message center
            // initialize and print messages
            this.messageCenterView.on('messageCenter:messages:initialize', function() {
                fetchMessages(initMessages);
            });


            function fetchMessages (callback) {
                if(requestMessageListData) {
                    callback.apply(self, [requestMessageListData]);
                } else {
                    if (App.MessageCenterApp.Requests) {
                        App.MessageCenterApp.Requests.getMessagesList().done(function(data) {
                            callback.apply(self, [data]);
                            requestMessageListData = data;
                        });
                    }
                    else {
                        callback.apply(self, [MESSAGES_LIST]);
                        requestMessageListData = MESSAGES_LIST;
                    }
                }
            };

            function initCountMessages (data) {
                self.messageCenterView.countNewMessages = _.where(data.output.feeds, {seen: false}).length;
                App.trigger('messageCenter:setCountNewMessages', self.messageCenterView.countNewMessages);
            };

            function initMessages (data) {
                self.messagesBoxView = new App.MessageCenterApp.Views.MessagesBox({collection: new App.MessageCenterApp.Entities.MessagesCollection()});

                self.messagesRegion = new Backbone.Marionette.Region({el: self.messageCenterView.ui.messagesListContainer});
                self.messagesRegion.show(self.messagesBoxView);

                self.messagesBoxView.collection.add(data.output.feeds);

                self.messageCenterView.countNewMessages = _.where(data.output.feeds, {seen: false}).length;
                self.messageCenterView.countAllMessages = data.output.count;

                App.trigger('messageCenter:setCountNewMessages', self.messageCenterView.countNewMessages);
                App.trigger('messageCenter:messages:inited');

                initMessageBoxHandlers();
            };

            function initMessageBoxHandlers () {
                // init handlers
                self.messagesBoxView.on('childview:messageCenter:messages:delete', function(childview) {
                    self.messageCenterView.markedForDeleteView = childview;
                    self.messageCenterView.trigger('messageCenter:messages:delete');
                });

                App.on('messageCenter:messages:delete:confirmed', function() {
                    var view = self.messageCenterView.markedForDeleteView,
                        id = view.model.get('id'),
                        type = view.model.get('type');

                    App.MessageCenterApp.Requests.deleteMessage(id, type).done(function(data) {
                        if(data.status === 1) {
                            !view.model.get('seen') && self.messageCenterView.countNewMessages--;
                            self.messageCenterView.markedForDeleteView.trigger('messageCenter:messages:successfullyDeleted');
                        }

                        App.trigger('messageCenter:setCountNewMessages', self.messageCenterView.countNewMessages);
                        App.trigger('messageCenter:messages:successfullyDeleted');
                        self.messageCenterView.trigger('messageCenter:recalculateCountMessages', self.messagesBoxView.collection.length);
                    });
                });

                App.on('messageCenter:messages:delete:canceled', function() {
                    var view = self.messageCenterView.markedForDeleteView;

                    view.trigger('messageCenter:messages:delete:canceled');
                });

                self.messagesBoxView.on('childview:messageCenter:messages:openNewMessage', function(childview) {
                    var model = childview.model,
                        id = model.get('id'),
                        type = model.get('type');

                    var markAsViewed = function(data) {
                        if(data.status === 1) {
                            !childview.model.get('seen') && self.messageCenterView.countNewMessages--;
                            childview.trigger('messageCenter:messages:successfullyViewed');
                        }

                        App.trigger('messageCenter:setCountNewMessages', self.messageCenterView.countNewMessages);
                    };

                    if(App.MessageCenterApp.Requests) {
                        App.MessageCenterApp.Requests.markMessageAsViewed(id, type).done(markAsViewed);
                    } else {
                        markAsViewed({status:1});
                    }
                });
            };

        }
    });
});
